<template>
  <b-container class="categories-page py-4">
    <h1 class="mb-4">Categorías</h1>
    
    <b-row>
      <b-col 
        v-for="category in categories" 
        :key="category.id"
        cols="12" 
        sm="6" 
        md="4" 
        lg="3"
        class="mb-4">
        <b-card 
          @click="goToProducts(category)"
          class="category-card h-100"
          no-body>
          <b-card-body class="text-center d-flex flex-column justify-content-center">
            <b-icon 
              icon="folder" 
              font-scale="3" 
              variant="primary"
              class="mb-3">
            </b-icon>
            <h5 class="mb-2">{{ category.name }}</h5>
            <p class="text-muted small mb-0">
              {{ category.products_count || 0 }} productos
            </p>
          </b-card-body>
          
          <b-list-group v-if="category.children && category.children.length > 0" flush>
            <b-list-group-item 
              v-for="subcat in category.children.slice(0, 3)" 
              :key="subcat.id"
              @click.stop="goToProducts(subcat)"
              class="subcategory-item">
              <b-icon icon="chevron-right" class="mr-2"></b-icon>
              {{ subcat.name }}
            </b-list-group-item>
            <b-list-group-item 
              v-if="category.children.length > 3"
              @click.stop="goToProducts(category)"
              class="text-center text-primary">
              Ver todas ({{ category.children.length }})
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    
    <div v-if="categories.length === 0" class="text-center py-5">
      <b-spinner large variant="primary"></b-spinner>
      <p class="mt-3">Cargando categorías...</p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'ProductCategories',
  computed: {
    categories() {
      // Solo mostrar categorías principales (sin parent_id)
      return this.$store.state.categories.filter(cat => !cat.parent_id)
    }
  },
  created() {
    this.$store.dispatch('loadCategories')
  },
  methods: {
    goToProducts(category) {
      this.$router.push({ 
        name: 'Products', 
        query: { category: category.id }
      })
    }
  }
}
</script>

<style scoped>
.category-card {
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  min-height: 200px;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.subcategory-item {
  cursor: pointer;
  transition: background-color 0.2s;
}

.subcategory-item:hover {
  background-color: #f8f9fa;
}
</style>